<template>
    <router-view />
</template>

<script lang="ts" setup>
</script>

<style lang="stylus">
    :deep(.el-table)
        font-size 12px !important
    .el-loading-mask
        position fixed !important
    .el-table + .el-pagination
        margin-top 20px
    .el-pagination
        text-align right
        
    .el-menu-item:hover
        outline 0 !important
        color #409EFF !important
    .el-submenu__title:focus, .el-submenu__title:hover
        outline 0 !important
        color #fff !important
        background #435EBE !important
        border-radius 8px !important
    .el-menu-item:hover
        outline 0 !important
        color #fff !important
        background #435EBE !important
        border-radius 8px !important
    
    .main-container
        padding 20px
        &.has-table
            height calc(100vh - 50px)
            box-sizing border-box
            display flex
            flex-direction column
    .filter-container
        padding-bottom 10px
        .filter-item, .filter-divider, .filter-btn
            display inline-block
            vertical-align middle
            margin 0 10px 10px 0 !important
        .filter-item
            &.el-input, &.el-select, &.el-select-v2, &.el-autocomplete
                width 180px
        .filter-divider
            color #999
    .action-list
        .el-tag, .el-button
            margin-right 8px
            margin-left 0 !important
            cursor pointer
            &:last-child
                margin-right 0
        .el-button--mini
            min-height 20px
            padding 7px 8px
</style>
